/**
 * @file: onErrorAlert.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { showAlert } from './showAlert';

export function onErrorAlert(error: any): void {
  try {
    console.error(error);
  } catch {}
  void showAlert('出错了', (error as Error)?.message ?? 'unknown error');
}
